import React from 'react';
import ScrollTrigger from 'react-scroll-trigger';
import BlackOverlay from '../../partials/black_overlay';
import BackgroundImage from '../../partials/background_image';
import Footer from '../footer';
import NavBar from '../navbar';
import { generateRandomId } from '../../../helpers';
import { Animated } from "react-animated-css";
import Contact from '../contact';
import Logo from '../logo';
import Burger from '../burger';

import "animate.css/animate.min.css";

// August 6th: refactored for responsiveness
class Two extends React.Component {
    state = {
        navBarTransparent: false,
        menuOpen: false
    }
    componentDidMount = () => { window.scrollTo(0, 0); }
    onEnterViewport = () => this.setState({ navBarTransparent: true });
    onExitViewport = () => this.setState({ navBarTransparent: false });
    onToggleMenu = () => this.setState({ menuOpen: !this.state.menuOpen });

    render() {
        const { navBarTransparent, menuOpen } = this.state, { nbs, title, bi, medal } = this.props;

        return <section>
            {/* Navbar */}
            <div className={`w3-top nav-bar  ${navBarTransparent ? 'nav-bar-transparent' : 'w3-card'}`}>
                <Contact />
                <div className={`w3-bar d-flex flex-row  w3-content font-11`} style={{ height: 70 }}>
                    <Logo className={`${(medal && medal.Medal) ? 'hide-768' : ''}`} medal={medal} />
                    <NavBar nbs={nbs} />
                    <a className="w3-button w3-padding-large ml-auto w3-hide-medium w3-hide-large flex-row justify-content-center burger bg-black" onClick={this.onToggleMenu} title="Toggle Navigation Menu">
                        <i className="fa fa-bars white align-self-center font-20" />
                    </a>
                </div>
            </div>
            <div className={`w3-sidebar w3-bar-block w3-card w3-animate-right w3-center bg-black white ${menuOpen ? '' : 'w3-hide'}`}
                style={{ right: 0, width: '90%', zIndex: 4 }}>
                <Burger onToggleMenu={this.onToggleMenu} />
            </div>
            <div className="bg-blackish pb-8">
                <div style={{ height: 600, position: 'relative' }} id="band">
                    <BackgroundImage key={generateRandomId(5)} bi={bi} />
                    <BlackOverlay />
                    <Animated animationIn="fadeInLeft" className="w-100 h-100 d-flex flex-row justify-content-center">
                        <h1 className="align-self-center hero-text anton text-center w-100">{title}</h1>
                    </Animated>
                    {/* In case of a medal, we hide the logo and show up the medal here */}
                    {medal && <section className="floating-medal" key={generateRandomId(5)}>
                        <Animated animationIn="fadeInLeft" className="d-flex flex-column h-100">
                            <img alt="" src={medal.Medal} style={{ maxHeight: 140 }} />
                            <span className="white anton font-14 toUpper align-self-center">{medal.Name}</span>
                        </Animated>
                    </section>}
                </div>

                {React.cloneElement(this.props.children, this.props)}
            </div>

            <ScrollTrigger onEnter={this.onEnterViewport} onExit={this.onExitViewport} triggerOnLoad={true}
                style={{ position: 'absolute', top: 150, height: 50 }} throttleScroll={0} />

            <footer className={`w3-container p-2 w3-black show`}>
                <Footer />
            </footer>
        </section>
    }
}

export default Two;


// WEBPACK FOOTER //
// ./src/components/layouts/six/index.js